export const SET_ALERT_BAR = 'ALERT_BAR/SET';
export const DISMISS_ALERT_BAR = 'ALERT_BAR/DISMISS';

export function setAlertBar({ active, timestamp }) {
  return {
    type: SET_ALERT_BAR,
    payload: {
      active: Boolean(active),
      timestamp: timestamp ?? null,
    },
  };
}

export function dismissAlertBar() {
  return {
    type: DISMISS_ALERT_BAR,
  };
}
